import { useRef } from 'react'
import { useSetState } from 'ahooks'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { SActionBtn, SBack, SDrawerOrModal, SLowcodeList, STableActions } from 'shj-components'

import { config } from './config.tsx'
import { StandardTable } from '../standard/index.tsx'
import styles from '@/pages/baseProduct/packageTemplate/addOrEdit/index.module.less'
import { AddOrEditProject } from '@/pages/baseProduct/subItemManage/addOrEdit/step2/addOrEdit/project.tsx'
import { getSubPackTreeTempTree } from '@/services/product.ts'
import { AddOrEditGeneral } from '@/pages/baseProduct/subItemManage/addOrEdit/step2/addOrEdit/general.tsx'
import { httpOrgList } from '@/services/homeService.ts'

export const ChildItemDetailTable = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [search] = useSearchParams()
  const packId = search.get('packId')
  const cacheId = search.get('cacheId')
  const listRef = useRef()
  const editRef = useRef()

  const [state, setState] = useSetState({
    visible: false,
    type: 'PRD_PROJECT',
    record: {},
    genItemId: '',
    companyList: [],
  })

  const fetchList = () => {
    if (!id) return Promise.reject()
    return new Promise((resolve, reject) => {
      getSubPackTreeTempTree({ subItemId: id, searchFlag: true })
        .then(res => {
          return resolve({ records: res })
        })
        .catch(reject)
    })
  }

  const onAddOrEdit = ({ record = {}, type = 'PRD_PROJECT' }: Record<string, any>) => {
    if (type === 'standard') setState({ visible: true, type, genItemId: record.busId })
    setState({ visible: true, type, record: { ...record } })
  }

  const getOptions = async () => {
    const companyList = await httpOrgList()
    setState({ companyList })
  }

  const extensions = {
    request: { fetchList, getOptions },
    customRender: {
      jsonRender({ filterJson }: any) {
        const { shops: list } = filterJson || {}
        return list?.map(item => item.name)?.join(', ')
      },
      actionRender(type: string, record) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onAddOrEdit({ type, record: record.object })}>
              详情
            </SActionBtn>
            {record.object?.standardFlag && (
              <SActionBtn onClick={() => onAddOrEdit({ type: 'standard', record: record.object })}>
                标配
              </SActionBtn>
            )}
          </STableActions>
        )
      },
    },
  }

  const onCancel = () => {
    setState({ visible: false, record: {} })
  }

  const onSubmit = () => {
    editRef.current?.onFinish()
  }

  const goBack = () => {
    if (packId || cacheId)
      navigate(
        `/config/baseProduct/packageTemplate/addOrEdit/${packId}?step=2&cacheId=${cacheId}`,
        { replace: true }
      )
    else {
      history.back()
    }
  }

  const modalObj = {
    PRD_PROJECT: {
      title: '项目',
      modalTitle: '项目详情',
      component: (
        <AddOrEditProject
          readOnly={true}
          {...state}
          ref={editRef}
          fn={listRef.current?.reload}
          onClose={onCancel}
        />
      ),
    },
    PRD_GEN_ITEM: {
      title: '通项',
      modalTitle: '通项详情',
      component: (
        <AddOrEditGeneral
          readOnly={true}
          {...state}
          ref={editRef}
          fn={listRef.current?.reload}
          onClose={onCancel}
        />
      ),
    },
    standard: {
      title: '标配',
      modalTitle: '标配',
      modalWidth: '800',
      component: <StandardTable genItemId={state.genItemId} readOnly={true} />,
    },
  }

  return (
    <SBack level={2} title={'子项详情'} goPath={goBack}>
      <div className={styles.container}>
        <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extensions} />
        <SDrawerOrModal
          title={modalObj[state.type].modalTitle}
          width={modalObj[state.type].modalWidth || 600}
          antdProps={{ footer: null }}
          open={state.visible}
          onOk={onSubmit}
          onCancel={onCancel}
        >
          {state.visible && modalObj[state.type].component}
        </SDrawerOrModal>
      </div>
    </SBack>
  )
}
